import { ElMessageBox } from 'element-plus';

export async function confirmRemoveCartItem(label?: string): Promise<boolean> {
  const message = label
    ? `Remove "${label}" from your cart?`
    : 'Remove this item from your cart?';

  try {
    await ElMessageBox.confirm(message, 'Remove item', {
      type: 'warning',
      confirmButtonText: 'Remove',
      cancelButtonText: 'Keep',
    });
    return true;
  } catch {
    return false;
  }
}
